<template lang="html">

  <section class="wrapper cv-area">

    <div class="container">


      <h2 class="title-section">

        <span @click="toggleedit">Datos de interés</span>

        <button @click="showedit= true" class="cv-action-button edit"
          v-if="!showedit & !noedit"></button>

        <button @click="showedit= false" class="cv-action-button close" v-if="showedit">✕</button>

      </h2>

      <div class="contenedor-datos row-start ais" v-if="!showedit && !!cvinteres">

        <article class="left">

          <p class="dato" v-if="!!rawdominios">
            <strong>Discapacidad certificada:</strong>
            <template v-if="!!rawdominios.discapacidad">
              {{(cvinteres.idTipoDiscapacidad) ? rawdominios.discapacidad[cvinteres.idTipoDiscapacidad]: 'Sin definir'}}
            </template>
          </p>
            <p class="dato" v-if="isEstudiante"><strong>Número de la Seguridad Social: </strong>{{(!!cvinteres.numSeguridadSocial) ? cvinteres.numSeguridadSocial : 'Sin definir'}}</p>
            <p class="dato" v-if="isEstudiante"><strong>Número de cuenta (IBAN): </strong>{{(!!cvinteres.IBAN) ? IBANpartido: 'Sin definir'}}</p>
          <p class="dato" v-if="usertype != 'practicas'"><strong>Perfiles digitales: </strong></p>

          <div class="perfiles-digitales row-start" v-if="usertype != 'practicas'">
            <a :active="!!cvinteres.perfilFB" target="_blank"
              :href="cvinteres.perfilFB | addhttp"><i class="fa fa-facebook"></i></a>
            <a :active="!!cvinteres.perfilTW" target="_blank"
              :href="cvinteres.perfilTW | addhttp"><i class="fa fa-twitter"></i></a>
            <a :active="!!cvinteres.perfilLinkedIn" target="_blank"
              :href="cvinteres.perfilLinkedIn | addhttp"><i class="fa fa-linkedin"></i></a>
          </div>

        </article>

        <article class="right">
          <p class="dato" v-if="isEstudiante"><strong>BIC: </strong>{{(!!cvinteres.BIC) ? cvinteres.BIC : 'Sin definir'}}</p>
          <p class="dato" v-if="isEstudiante"><strong>Acepta el paso a Alumni:</strong> {{(cvinteres.aceptaPasoAlumni)
            ? 'Sí' : 'No'}}</p>
        </article>

      </div>

      <div class="contenedor-datos -edicion row-start ais" v-if="showedit">
        <article class="left">


          <div class="contenedor-input">
            <label for="">Discapacidad certificada*</label>
            <select name="discapacidad" id=""
              v-model="editinteres.idTipoDiscapacidad" v-validate="'required'">
              <option v-for="(discapacidad,key) in rawdominios.discapacidad"
                :value="key">{{discapacidad}}</option>
            </select>
          </div>


          <div class="contenedor-input" v-if="isEstudiante">
            <label for="">Número de la Seguridad Social*</label>
            <input type="text" name="seguridadsocial" v-validate="'required'"
              v-model="editinteres.numSeguridadSocial">
            <span :class="['error',{'animated shake' : clicked}]"
              v-if="clicked">{{ errors.first('seguridadsocial') }}</span>
          </div>


          <div class="contenedor-input" v-if="isEstudiante">
            <label for="">Número de cuenta (IBAN)</label>
            <div class="contenedor-iban row-start">
            <template v-for="(number,key) of editinteres.splitIBAN">
              
                <input  type="text" :name="'iban-'+key" v-model="editinteres.splitIBAN[key]" :maxlength="''+ibanpositions[key]" >
            
            </template>
          </div>


            
       

            <span :class="['error',{'animated shake' : clicked}]"
            v-if="clicked">{{ errors.first('iban') }}</span>
          </div>


          <div class="contenedor-input" v-if="isAlumni">
            <label for="">Facebook</label>
            <input type="text" name="facebook" v-validate="'url'"
              v-model="editinteres.perfilFB">
            <span :class="['error',{'animated shake' : clicked}]"
              v-if="clicked">{{ errors.first('facebook') }}</span>
          </div>

          <div class="contenedor-input" v-if="isAlumni">
            <label for="">Twitter</label>
            <input type="text" name="twitter" v-validate="'url'"
              v-model="editinteres.perfilTW">
            <span :class="['error',{'animated shake' : clicked}]"
              v-if="clicked">{{ errors.first('twitter') }}</span>
          </div>

          <div class="contenedor-input" v-if="isAlumni">
            <label for="">Linkedin</label>
            <input type="text" name="linkedin" v-validate="'url'"
              v-model="editinteres.perfilLinkedIn">
            <span :class="['error',{'animated shake' : clicked}]"
              v-if="clicked">{{ errors.first('linkedin') }}</span>
          </div>

        </article>

        <article class="right">


          <div class="contenedor-input" v-if="isEstudiante">
            <label for="">BIC</label>
            <input type="text" name="bic" v-model="editinteres.BIC">
          </div>

          <div class="contenedor-check -input" v-if="isEstudiante">
            <input type="checkbox" id="acepta-el-paso"
              v-model="editinteres.aceptaPasoAlumni">
            <label for="acepta-el-paso">Acepta el paso a alumni</label>
          </div>

        </article>

        <div class="contenedor-boton">
          <button :loading="loading" @click="send" class="btn">Guardar</button>
        </div>

      </div>

      <div class="contenedor-check" v-if="isAlumni & !!cvinteres">
        <input type="checkbox" id="ofertas-dirigidas"
          v-model="editinteres.quiereRecibirOfertas" @change="setQuiereRecibirOfertas">
        <label for="ofertas-dirigidas">Quiero recibir por correo electrónico las
          ofertas de empleo dirigidas a mi
          titulación</label>
      </div>


    </div>

  </section>


</template>

<script lang="js">

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  Vue.use(VeeValidate);

  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'datos-interes',
    props : ['cvinteres','noedit'],
    mounted(){
      this.editinteres.quiereRecibirOfertas = this.cvinteres.quiereRecibirOfertas 
    },
    data() {
      return {
        showedit: false,
        clicked : false,
        loading : false,
        ibanpositions : [4,4,4,2,10],
        editpersonales : {
          sexo : '',
          idNacionalidad : '',
          idPaisResidencia : '',
        },
        editinteres : {
          discapacidad: null,
          idTipoDiscapacidad: 0,
          tipoDiscapacidad: "",
          perfilFB: "",
          perfilTW: "",
          perfilLinkedIn: "",
          quiereRecibirOfertas : null,
          aceptaPasoAlumni: null,
          IBAN:"",          
          splitIBAN : [],
          BIC: "",
          numSeguridadSocial: ""
        }
      }
    },
    computed :  {
      ...mapGetters({
        isAlumni : 'isAlumni',
        isEstudiante : 'isEstudiante',
        dominios : 'getDominiosOrder',
        rawdominios : 'getDominios',
        usertype : 'getusertype'
      }),
      IBANpartido:function()
      {
        return this.cvinteres.IBAN.substring(0, 4)+" "+this.cvinteres.IBAN.substring(4, 8)+
                " "+this.cvinteres.IBAN.substring(8, 12)+" "+this.cvinteres.IBAN.substring(12, 14)+" "+this.cvinteres.IBAN.substring(14, this.cvinteres.IBAN.length)
      }
    },
    methods: {
      ...mapActions(['requestUpdatePersonales','requestUpdateInteres']),
      toggleedit(){
        if(!this.noedit){
          this.showedit = !this.showedit
        }
      
      },
      send() {
        this.clicked = true;
        this.$validator.validateAll()
          .then(itsOk => {
            if (itsOk) {              
              this.loading = true;
              this.editinteres.IBAN=this.editinteres.splitIBAN.join('');
                this.requestUpdateInteres(this.editinteres).then(r => {
                  this.loading = false;
                  if(r) this.showedit = false;                     
                });
            }
          });
      },
      setQuiereRecibirOfertas(){

        let data = {
          quiereRecibirOfertas : this.editinteres.quiereRecibirOfertas
        };

        this.requestUpdateInteres(data);
      }
    },
    filters : {
      'addhttp'(value){
        if(!!value){
          if(!value.includes('http')){
            value = 'http://'+value;
          }
        }
        return value;
      }
    },
    watch : {
      'showedit'(){
        if(this.showedit){
        
          for(let i in this.editinteres){
            this.editinteres[i] = this.cvinteres[i];
          }
            this.editinteres.splitIBAN = new Array(this.ibanpositions.length);
          
          if(!!this.cvinteres.IBAN){

            let init = 0;
            this.ibanpositions.forEach((e,key) => {
              this.editinteres.splitIBAN[key] = this.cvinteres.IBAN.substring(init,e+init);
              init = e+init;
            })
          }
          
        }
      },
      'cvinteres.quiereRecibirOfertas'(){
        this.editinteres.quiereRecibirOfertas = this.cvinteres.quiereRecibirOfertas 
      }
    }
  }
</script>

<style scoped lang="scss">
  .contenedor-check:not(.-input) {
    margin-top: 30px;
  }

  .contenedor-iban input{
    width: auto;
    max-width: 50px;
    margin: 0 3px;
    &:last-of-type{
      max-width: 200px;
    }
  }

  @media screen and (max-width: 650px) {
    .contenedor-check[data-v-0010d2a3]:not(.-input){
      margin-top: 15px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/view-parts/espacio-personal/datos-interes.vue